import type { RowType } from 'Services/ProductManagement/Features/Product/Components/ProductPricing/types'
import type { GridCellParams } from '@mui/x-data-grid'

/**
 * Creates a value formatter for pricing grid cells.
 * Exchange period values are formatted as minutes, pricing values as EUR currency.
 */
export const createGridValueFormatter =
  (isExchangePeriodTab: boolean) =>
  (value: number | string | null): string => {
    if (value == null || value === '') {
      return ''
    }

    if (typeof value === 'string') {
      return value
    }

    if (isExchangePeriodTab) {
      return new Intl.NumberFormat('fi-FI', {
        style: 'unit',
        unit: 'minute'
      }).format(value)
    }

    return new Intl.NumberFormat('fi-FI', { style: 'currency', currency: 'EUR' }).format(value)
  }

/**
 * Creates a cell class name getter that highlights edited and updated cells.
 */
export const createGetCellClassName = (
  editedPricingCells: RowType[],
  updatedPricingCells: RowType[],
  gridInstanceId: number,
  editedClassName: string,
  updatedClassName: string
) => {
  return (params: GridCellParams): string => {
    const matchesCell = (cell: RowType) =>
      cell.id === params.id && cell.field === params.field && cell.gridId === gridInstanceId

    if (editedPricingCells.length > 0) {
      return editedPricingCells.some(matchesCell) ? editedClassName : ''
    }

    return updatedPricingCells.some(matchesCell) ? updatedClassName : ''
  }
}
